import { Action, Seed } from "domain/aangifte";
import { cities, City } from "domain/cities/cities";
import { option } from "fp-ts";
import { constUndefined, pipe } from "fp-ts/lib/function";

export type CityReducer = (City & { postalcode: string }) | undefined;

export interface UpdatePostalcode {
  type: "UPDATE_POSTALCODE";
  postalcode: string;
}

const lookupCity = (postalcode?: string): CityReducer => {
  return pipe(
    option.fromNullable(postalcode),
    option.chain(cities.tryFind),
    option.fold(constUndefined, (city) => ({ ...city, postalcode: postalcode as string }))
  );
};

export const init = (seed?: Seed): CityReducer => {
  return lookupCity(seed?.postalcode);
};

export const update = (action: Action) => (city: CityReducer): CityReducer => {
  switch (action.type) {
    case "UPDATE_POSTALCODE":
      return lookupCity(action.postalcode);
    case "RESET":
      return undefined;
    default:
      return city;
  }
};
